'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Attachment = function Attachment(_ref) {
  var color = _ref.color,
      size = _ref.size;
  return _react2.default.createElement(
    'svg',
    {
      width: size,
      height: size,
      viewBox: '0 0 32 32'
    },
    _react2.default.createElement('path', {
      d: 'M7.75 29.109c-1.895 0-3.483-.64-4.763-1.92-1.28-1.28-1.92-2.868-1.92-4.764 0-2.188.81-4.091 2.43-5.712L15.307 4.88c1.864-1.831 4.06-2.747 6.587-2.747 2.576 0 4.764.891 6.562 2.674 1.799 1.782 2.698 3.961 2.698 6.538 0 2.56-.915 4.771-2.746 6.635l-12.425 12.4c-.674.674-1.779.518-2.273.024-.494-.494-.484-1.617.11-2.212l12.449-12.424c1.247-1.28 1.871-2.746 1.871-4.4 0-1.717-.607-3.167-1.823-4.35-1.215-1.182-2.681-1.774-4.399-1.774-1.701 0-3.167.616-4.399 1.847L5.685 18.9c-1.021 1.021-1.532 2.196-1.532 3.525 0 1.037.34 1.896 1.021 2.576.68.68 1.54 1.02 2.576 1.02 1.329 0 2.504-.51 3.525-1.53l9.743-9.743c.388-.422.583-.908.583-1.459 0-.47-.154-.858-.462-1.166-.308-.308-.697-.462-1.167-.462-.518 0-.996.202-1.433.608l-8.424 8.423c-.723.664-1.83.465-2.333-.038-.502-.502-.418-1.516.146-2.15l8.423-8.423c.989-1.02 2.196-1.531 3.621-1.531 1.33 0 2.455.462 3.379 1.385.923.924 1.385 2.05 1.385 3.379 0 1.426-.51 2.633-1.531 3.621l-9.743 9.743c-1.588 1.62-3.492 2.43-5.712 2.43z',
      fill: color
    })
  );
};

Attachment.defaultProps = {
  color: '#48487E',
  size: 32
};

Attachment.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number
};

exports.default = Attachment;